module.exports = __webpack_public_path__ + "img/victron_220_agm.814f4670.png";